import { BaseSite } from "fleet/view/application/base-site";
import { IncidentDetailReportPage } from "fleet/view/report/incident-detail-report-page";
import PropTypes from "prop-types";
import React from "react";
import { getErrorMessage } from "util/response";

class ReportIncidentDetail extends React.PureComponent {
  static get propTypes() {
    return {
      authenticated: PropTypes.bool.isRequired,
      jwtToken: PropTypes.string.isRequired,
      fetchIncidentDetailReport: PropTypes.func.isRequired,
    };
  }

  constructor() {
    super();

    this.state = {
      data: [],
    };

    this._loadSuccessHandler = this._loadSuccessHandler.bind(this);
    this._loadFailureHandler = this._loadFailureHandler.bind(this);
  }

  componentDidMount() {
    const { fetchIncidentDetailReport, jwtToken } = this.props;

    return fetchIncidentDetailReport(jwtToken)
      .then(this._loadSuccessHandler)
      .catch(this._loadFailureHandler);
  }

  _loadSuccessHandler(resp) {
    const { data } = resp;

    this.setState({ data });
  }

  _loadFailureHandler(err) {
    const errorMessage = "Incident Detail API: " + getErrorMessage(err);

    this.setState({ errorMessage });
  }

  render() {
    const { authenticated } = this.props;
    const { data, errorMessage } = this.state;

    if (authenticated) {
      return (
        <IncidentDetailReportPage
          reportData={data}
          errorMessage={errorMessage}
        />
      );
    }

    return (
      <BaseSite sidebar={false}>
        <IncidentDetailReportPage
          reportData={data}
          errorMessage={errorMessage}
        />
      </BaseSite>
    );
  }
}

export { ReportIncidentDetail };
